/**
 * Phosphor-иконки категорий каталога услуг (D5b: weight regular, цвет
 * наследуется — по решению Артёма 2026-05-24, п.1 «выбираем phosphor»).
 *
 * Финальный маппинг по согласованному guest v7 §15
 * (https://static.dzenflow.com/lovart-hotels-design-guest-v7-2026-06-11.html):
 *   housekeeping=Broom, maintenance=Wrench, room_service=ForkKnife,
 *   minibar=Wine, laundry=TShirt, transfer=CarSimple, excursions=MapTrifold,
 *   spa=Flower, front_desk=CallBell. Подкатегории: полотенца=Towel, кровать=Bed.
 *
 * Ключи маппинга = `code` категории из seed (db/migrations/tenant/0052) плюс
 * типовые синонимы кастомных категорий. Неизвестный код получает нейтральную
 * Sparkle — каталог расширяется данными, фронт не должен падать на новой
 * категории.
 */
import type { Icon } from '@phosphor-icons/react';
import {
  Bed,
  Bell,
  Broom,
  CallBell,
  CalendarCheck,
  CarSimple,
  Flower,
  ForkKnife,
  MapTrifold,
  Question,
  Sparkle,
  Towel,
  TShirt,
  Wine,
  Wrench,
} from '@phosphor-icons/react';

const ICON_BY_CODE: Readonly<Record<string, Icon>> = {
  /* Seed-категории (canon §15 — финальный маппинг). */
  housekeeping: Broom,
  maintenance: Wrench,
  room_service: ForkKnife,
  minibar: Wine,
  laundry: TShirt,
  concierge: Bell,
  transfer: CarSimple,
  excursions: MapTrifold,
  spa: Flower,
  front_desk: CallBell,
  /* Синонимы типовых кастомных категорий. */
  cleaning: Broom,
  f_and_b: ForkKnife,
  restaurant: ForkKnife,
  bar: Wine,
  guest_services: CallBell,
  wellness: Flower,
  transport: CarSimple,
  excursion: MapTrifold,
  booking: CalendarCheck,
  /* Подкатегории (canon §15): полотенца / постель. */
  towels: Towel,
  bed: Bed,
  /* «Другое — опишите» — последняя tile-строка списка услуг (canon §15). */
  other: Question,
};

/** Phosphor-компонент для кода категории (Sparkle — фоллбэк). */
export function iconForCategoryCode(code: string): Icon {
  return ICON_BY_CODE[code] ?? Sparkle;
}

export interface CategoryIconProps {
  /** Машинный код категории (service_categories.code). */
  code: string;
  /** Размер в px, по умолчанию 22. */
  size?: number;
  className?: string;
}

/** Иконка категории каталога: 2px stroke, regular weight, цвет inherit. */
export function CategoryIcon({ code, size = 22, className }: CategoryIconProps): JSX.Element {
  const IconCmp = iconForCategoryCode(code);
  return <IconCmp size={size} weight="regular" aria-hidden="true" className={className} />;
}
